import { CSSProperties } from 'react';
import { s8, colors } from '@ardoq/design-tokens';
import { SvgImage, SvgImageName } from '@ardoq/icons';

type LoadingScreenLogoProps = {
  svgImageName?: SvgImageName;
  width?: number;
  height?: number;
  style?: CSSProperties;
  color?: string;
};

export const LoadingScreenLogo = ({
  svgImageName,
  height,
  style,
  width,
}: LoadingScreenLogoProps) => (
  <SvgImage
    svgImageName={svgImageName ?? SvgImageName.ARDOQ_LOGO_WITH_NAME}
    style={{
      color: colors.brand950,
      width: width ?? 94,
      height: height ?? 72,
      marginTop: s8,
      position: 'absolute',
      ...style,
    }}
  />
);
